import { render, staticRenderFns } from "./NotificationListItem.vue?vue&type=template&id=64601abe&"
import script from "./NotificationListItem.vue?vue&type=script&lang=js&"
export * from "./NotificationListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports